<template>
  <button
    type="button"
    class="absolute w-7 h-7 rounded-full text-gray-1000 dark:text-white border border-solid border-gray-500 dark:border-gray-600 flex items-center justify-center bg-gray-100 dark:bg-gray-900 hover:!border-primary-600 hover:!text-primary-600 transition-all duration-300 ease-in-out"
  >
    <slot></slot>
  </button>
</template>
